<template>
  <div class="search">
    <Row>
      <Col>
        <Card>
          <Row @keydown.enter.native="handleSearch">
            <Form ref="searchForm" :model="searchForm" inline :label-width="70" class="search-form">
              <Form-item label="自增ID" prop="id">
                <Input type="text" v-model="searchForm.id" placeholder="请输入自增ID" clearable style="width: 200px"/>
              </Form-item>
              <Form-item label="应用编码" prop="code">
                <Input type="text" v-model="searchForm.code" placeholder="请输入应用编码" clearable style="width: 200px"/>
              </Form-item>
              <span v-if="drop">
                <Form-item label="渠道名称" prop="channelName">
                  <Input type="text" v-model="searchForm.channelName" placeholder="请输入渠道名称" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="分组名称" prop="groupName">
                  <Input type="text" v-model="searchForm.groupName" placeholder="请输入分组名称" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="关键词" prop="keywords">
                  <Input type="text" v-model="searchForm.keywords" placeholder="请输入关键词" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="提交次数" prop="submitCount">
                  <Input type="text" v-model="searchForm.submitCount" placeholder="请输入提交次数" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="姓名" prop="name">
                  <Input type="text" v-model="searchForm.name" placeholder="请输入姓名" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="微信" prop="weChat">
                  <Input type="text" v-model="searchForm.weChat" placeholder="请输入姓名" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="电话" prop="mobilePhone">
                  <Input type="text" v-model="searchForm.mobilePhone" placeholder="请输入电话" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="邮箱" prop="email">
                  <Input type="text" v-model="searchForm.email" placeholder="请输入邮箱" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="需求" prop="demand">
                  <Input type="text" v-model="searchForm.demand" placeholder="请输入需求" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="提交时间" prop="createDate">
                <DatePicker v-model="selectDate" type="daterange" format="yyyy-MM-dd" clearable @on-change="selectDateRange" placeholder="选择起始时间" style="width: 200px"></DatePicker>
              </Form-item>
              </span>
              <Form-item style="margin-left:-35px;" class="br">
                <Button @click="handleSearch" type="primary" icon="ios-search">搜索</Button>
                <Button @click="exportData" type="primary" icon="ios-search">根据查询条件导出</Button>
                <Button @click="handleReset">重置</Button>
                <a class="drop-down" @click="dropDown">
                  {{dropDownContent}}
                  <Icon :type="dropDownIcon"></Icon>
                </a>
              </Form-item>
            </Form>
          </Row>
          <Row class="operation">
            <Button @click="getDataList" icon="md-refresh">刷新</Button>
          </Row>
          <Row>
            <Table :loading="loading" border :columns="columns" :data="data" ref="table" sortable="custom" @on-sort-change="changeSort" @on-selection-change="changeSelect"></Table>
          </Row>
          <Row type="flex" justify="end" class="page">
            <Page :current="searchForm.pageNumber" :total="total" :page-size="searchForm.pageSize" @on-change="changePage" @on-page-size-change="changePageSize" :page-size-opts="[10,20,50]" size="small" show-total show-elevator show-sizer></Page>
          </Row>
        </Card>
      </Col>
    </Row>
    <Modal :title="modalTitle" v-model="modalVisible" :mask-closable='false' :width="500">
      <Form ref="form" :model="form" :label-width="100" :rules="formValidate" >
        <FormItem label="自增ID" prop="id" style="display: none">
          <Input v-model="form.id" style="width:100%"/>
        </FormItem>
        <FormItem label="应用编码" prop="code" >
          <Input v-model="form.code" style="width:100%"/>
        </FormItem>
        <FormItem label="渠道名称" prop="channelName" >
          <Input v-model="form.channelName" style="width:100%"/>
        </FormItem>
        <FormItem label="分组名称" prop="groupName" >
          <Input v-model="form.groupName" style="width:100%"/>
        </FormItem>
        <FormItem label="关键词" prop="keywords" >
          <Input v-model="form.keywords" style="width:100%"/>
        </FormItem>
        <FormItem label="提交次数" prop="submitCount" >
          <Input v-model="form.submitCount" style="width:100%"/>
        </FormItem>
        <FormItem label="姓名" prop="name" >
          <Input v-model="form.name" style="width:100%"/>
        </FormItem>
        <FormItem label="电话" prop="mobilePhone" >
          <Input v-model="form.mobilePhone" style="width:100%"/>
        </FormItem>
        <FormItem label="邮箱" prop="email" >
          <Input v-model="form.email" style="width:100%"/>
        </FormItem>
        <FormItem label="需求" prop="demand" >
          <Input v-model="form.demand" style="width:100%"/>
        </FormItem>
        <FormItem label="创建者" prop="createBy" >
          <Input v-model="form.createBy" style="width:100%"/>
        </FormItem>
        <FormItem label="创建时间" prop="createDate" >
          <Input v-model="form.createDate" style="width:100%"/>
        </FormItem>
        <FormItem label="更新者" prop="updateBy" >
          <Input v-model="form.updateBy" style="width:100%"/>
        </FormItem>
        <FormItem label="更新时间" prop="updateDate" >
          <Input v-model="form.updateDate" style="width:100%"/>
        </FormItem>
        <FormItem label="备注信息" prop="remarks" >
          <Input v-model="form.remarks" style="width:100%"/>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="modalVisible=false">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "MajiabaoDemand",
  components: {
  },
  data() {
    return {
      loading: true, // 表单加载状态
      modalType: 0, // 添加或编辑标识
      modalVisible: false, // 添加或编辑显示
      modalTitle: "", // 添加或编辑标题
      drop: false,
      dropDownContent: "展开",
      dropDownIcon: "ios-arrow-down",
      searchForm: { // 搜索框初始化对象
        pageNumber: 1, // 当前页数
        pageSize: 10, // 页面大小
        sort: "a.create_date", // 默认排序字段
        order: "desc", // 默认排序方式
        startDate: "", // 起始时间
        endDate: "" // 终止时间
      },
      selectDate: null,
      form: { // 添加或编辑表单对象初始化数据
        id: "",
        code: "",
        channelName: "",
        groupName: "",
        keywords: "",
        submitCount: "",
        name: "",
        weChat: "",
        mobilePhone: "",
        email: "",
        demand: "",
        createBy: "",
        createDate: "",
        updateBy: "",
        updateDate: "",
        remarks: "",
        delFlag: "",
      },
      // 表单验证规则
      formValidate: {
      },
      submitLoading: false, // 添加或编辑提交状态
      selectList: [], // 多选数据
      selectCount: 0, // 多选计数
      columns: [
        // 表头
        {
          type: "index",
          width: 60,
          align: "center"
        },
        {
          title: "自增ID",
          key: "id",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "应用编码",
          key: "code",
          minWidth: 120,
          sortable: false,
        },{
          title: "渠道名称",
          key: "channelName",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "分组名称",
          key: "groupName",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "关键词",
          key: "keywords",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "提交次数",
          key: "submitCount",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "姓名",
          key: "name",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "微信",
          key: "weChat",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "电话",
          key: "mobilePhone",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "邮箱",
          key: "email",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "需求",
          key: "demand",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "提交时间",
          key: "createDate",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "操作",
          key: "action",
          align: "center",
          width: 200,
          fixed: 'right',
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                    icon: "ios-create-outline"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.edit(params.row);
                    }
                  }
                },
                "详情"
              )
            ]);
          }
        }
      ],
      data: [], // 表单数据
      total: 0 // 表单数据总数
    };
  },
  methods: {
    init() {
      this.getDataList();
    },
    changePage(v) {
      this.searchForm.pageNumber = v;
      this.getDataList();
      this.clearSelectAll();
    },
    changePageSize(v) {
      this.searchForm.pageSize = v;
      this.getDataList();
    },
    handleSearch() {
      this.searchForm.pageNumber = 1;
      this.searchForm.pageSize = 10;
      this.getDataList();
    },
    handleReset() {
      this.$refs.searchForm.resetFields();
      this.searchForm.pageNumber = 1;
      this.searchForm.pageSize = 10;
      this.selectDate = null;
      this.searchForm.startDate = "";
      this.searchForm.endDate = "";
      // 重新加载数据
      this.getDataList();
    },
    changeSort(e) {
      this.searchForm.sort = e.key;
      this.searchForm.order = e.order;
      if (e.order === "normal") {
        this.searchForm.order = "";
      }
      this.getDataList();
    },
    clearSelectAll() {
      this.$refs.table.selectAll(false);
    },
    changeSelect(e) {
      this.selectList = e;
      this.selectCount = e.length;
    },
    selectDateRange(v) {
      if (v) {
        this.searchForm.startDate = v[0];
        this.searchForm.endDate = v[1];
      }
    },
    dropDown() {
      if (this.drop) {
        this.dropDownContent = "展开";
        this.dropDownIcon = "ios-arrow-down";
      } else {
        this.dropDownContent = "收起";
        this.dropDownIcon = "ios-arrow-up";
      }
      this.drop = !this.drop;
    },
    getDataList() {
      this.loading = true;
      // 带多条件搜索参数获取表单数据 请自行修改接口
       this.getRequest("/majiabaoDemand/getByPage", this.searchForm).then(res => {
         this.loading = false;
         if (res.success) {
           this.data = res.result.records;
           this.total = res.result.total;
         }
       });
    },
    edit(v) {
      this.modalType = 1;
      this.modalTitle = "编辑";
      this.$refs.form.resetFields();
      // 转换null为""
      for (let attr in v) {
        if (v[attr] === null) {
          v[attr] = "";
        }
      }
      let str = JSON.stringify(v);
      let data = JSON.parse(str);
      this.form = data;
      this.modalVisible = true;
    },
    exportData() {
      this.loading = true;
      // 带多条件搜索参数获取表单数据 请自行修改接口
      this.getRequest("/majiabaoDemand/export", this.searchForm, 'blob').then(response => {
        this.loading = false;
        var blob = new Blob([response])
        var downloadElement = document.createElement('a');
        var href = window.URL.createObjectURL(blob); //创建下载的链接
        downloadElement.href = href;
        downloadElement.download = '需求数据.xlsx'; //下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象

        console.log(response);
      });
      // 以下为模拟数据
      //this.data = [
      //];
      // this.total = this.data.length;
      // this.loading = false;
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="less">
.search {
    .operation {
        margin-bottom: 2vh;
    }
    .select-count {
        font-size: 13px;
        font-weight: 600;
        color: #40a9ff;
    }
    .select-clear {
        margin-left: 10px;
    }
    .page {
        margin-top: 2vh;
    }
    .drop-down {
        font-size: 13px;
        margin-left: 5px;
    }
}
</style>